// DANCE WORKSHOP VIDEOS
// Add a new { title, url } entry below for each YouTube video you want to
// feature. Paste any standard YouTube link (youtube.com/watch?v=... or
// youtu.be/...) — the thumbnail is pulled automatically from YouTube itself,
// so there's no image to upload or keep in sync.
export const danceVideos = [
    { title: "GOOD SO BAD - ZEROBASEONE // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=u_BvxOU62y4" },
    { title: "WE ON FIRE - &TEAM // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=J0-pl33Z1Vs" },
    { title: "BAD - ATEEZ // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=GmY-B9kPvzQ" },
    { title: "RUDE! - HEARTS2HEARTS // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=N7bFNZ1wAI8" },
    { title: "TOP 5 - ZEROBASEONE // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=kuMT1qGQ3TI" },
    { title: "2.0 - BTS // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=8si434QHIno" },
    { title: "REDRED - CORTIS // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=BuqgbKxZFZM" },
    { title: "THAT'S A NO NO- ITZY // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=9aSJ6-EUXCU" },
    { title: "TWEAK - GIRLSET // UNSW KPOP SOCIETY", url: "https://www.youtube.com/watch?v=CC7Yd4FKQE0" },
]